import PropTypes from 'prop-types';

const ExtraPropTypes = {
  eid: PropTypes.string.isRequired,
  extension: PropTypes.string,
  fileSize: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default ExtraPropTypes;
